import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PatchTask } from "@coworker/apprestructured/src/task-management/types/Task";
import { updateTask } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { invalidateTaskQueries } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";

export const useUpdateTask = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patchTask }: { id: string; patchTask: PatchTask }) =>
      updateTask(id, patchTask),
    onSuccess: () => {
      return invalidateTaskQueries(queryClient);
    },
  });
};
